import styled from 'styled-components'
import GlobalStyles from '../../../components/component-items/styles'

export const TableRow = styled(GlobalStyles.TableRow)<{
  $depth?: number
  $isParent?: boolean
  $isExpanded?: boolean
  $isLastChild?: boolean
}>`
  cursor: pointer;
  p {
    max-width: fit-content;
    margin-bottom: 0;
  }

  /* ── Option A: Subtle row tint (deeper = slightly darker) ──────────── */
  ${({ $depth }) =>
    $depth && $depth > 0 ? `td { background: rgba(93, 120, 255, ${Math.min($depth * 0.03, 0.09)}); }` : ''}

  /* ── Option B: Left accent border on children ──────────────────────── */
  ${({ $depth }) => ($depth && $depth > 0 ? `border-left: 3px solid #c9d0ff;` : '')}

  /* ── Option C: Thicker bottom border when parent collapses (group separator) */
  ${({ $isParent, $isExpanded }) => ($isParent && !$isExpanded ? `border-bottom: 2px solid #d5d9e8;` : '')}
`

export const DetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #ebedf2;
`

export const DetailInfo = styled.div`
  h3 {
    margin: 0 0 0.5rem;
    font-size: 1.25rem;
    font-weight: 600;
  }
  span {
    font-size: 0.9rem;
    color: #74788d;
    margin-right: 1.5rem;
  }
`

export const ActionsDropdown = styled.div`
  position: relative;
  display: inline-block;
  ul {
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 10;
    min-width: 14rem;
    box-shadow: 0 0 50px 0 rgba(82, 63, 105, 0.15);
    border-radius: 4px;
    background-color: #ffffff;
    padding: 1rem 0;
    margin: 0;
    list-style: none;
    border: 0;
    li {
      cursor: pointer;
      padding: 0.6rem 1.25rem;
      font-weight: 400;
      color: #595d6e;
      font-size: 0.9rem;
      &:hover {
        background-color: #f7f8fa;
      }
      &.danger {
        color: #fd397a;
        &:hover {
          background-color: rgba(253, 57, 122, 0.05);
        }
      }
    }
  }
`

export const TabContent = styled.div`
  padding: 1.5rem 2rem;
`

export const SummaryLine = styled.div`
  font-size: 0.9rem;
  color: #74788d;
  margin-bottom: 1rem;
`

// ── View toggle (segmented control) ─────────────────────────────────────────

export const ViewToggle = styled.div`
  display: inline-flex;
  border: 1px solid #e2e5ec;
  border-radius: 0.25rem;
  overflow: hidden;
`

export const ViewToggleBtn = styled.button<{ $active?: boolean }>`
  padding: 0.65rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.15s ease;
  background: ${({ $active }) => ($active ? '#5d78ff' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#ffffff' : '#595d6e')};
  &:hover {
    background: ${({ $active }) => ($active ? '#5d78ff' : '#f7f8fa')};
  }
`

// ── Tree view: chevron toggle ───────────────────────────────────────────────

export const ChevronBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #7e8299;
  font-size: 0.7rem;
  padding: 0;
  margin-right: 0.2rem;
  border-radius: 2px;
  &:hover {
    background: #f0f0f3;
    color: #3f4254;
  }
`

export const ContainerCardToolbar = styled(GlobalStyles.CardToolbar)`
  flex-wrap: wrap;
  gap: 0.5em;
`
